/**
 * Convert values to vw
 * @param {number} value
 * @param {boolean} unitless
 * @param {boolean} defaultWindowWidth
 * @return {string | number}
 */
export default (value, unitless = false, defaultWindowWidth = true) => {
    let windowWidth;
    let conversion;

    defaultWindowWidth ? windowWidth = window.innerWidth : windowWidth = 640;

    conversion = `${value / windowWidth * 100}vw`;

    if (unitless) {
        conversion = value / windowWidth * 100;
    }

    return conversion;
};
